import { render, staticRenderFns } from "./SetmealTableForm.vue?vue&type=template&id=c3f7151a&scoped=true&"
import script from "./SetmealTableForm.vue?vue&type=script&lang=js&"
export * from "./SetmealTableForm.vue?vue&type=script&lang=js&"
import style0 from "./SetmealTableForm.vue?vue&type=style&index=0&id=c3f7151a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f7151a",
  null
  
)

export default component.exports